var _g, _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigBlindCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2713_2928)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11,
    r: 9,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11,
    r: 5.34375,
    fill: "white",
    stroke: "#D7905D",
    strokeWidth: 0.5625
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8061 7.81531L18.9393 5.93307C18.6308 5.48093 18.2821 5.05837 17.8984 4.67052L17.8296 4.60172C17.4416 4.2179 17.0189 3.86912 16.5666 3.5605L14.6844 5.6937C15.5534 6.21631 16.2834 6.94635 16.8061 7.81531ZM16.806 14.1847C16.2833 15.0537 15.5533 15.7837 14.6843 16.3063L16.5665 18.4395C17.0223 18.1286 17.448 17.7768 17.8383 17.3896L17.8896 17.3382C18.2768 16.948 18.6284 16.5225 18.9392 16.067L16.806 14.1847ZM8.31535 16.3061C7.4464 15.7834 6.71636 15.0533 6.19375 14.1844L4.06061 16.0665C4.69609 16.9978 5.50188 17.8037 6.43316 18.4392L8.31535 16.3061ZM6.19366 7.8157C6.71626 6.9467 7.44628 6.21661 8.31522 5.69393L6.43307 3.56083C5.5018 4.19637 4.69602 5.00222 4.06055 5.93354L6.19366 7.8157Z",
    fill: "#D7905D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 11C14.875 12.864 13.364 14.375 11.5 14.375C9.63604 14.375 8.125 12.864 8.125 11C8.125 9.13604 9.63604 7.625 11.5 7.625C13.364 7.625 14.875 9.13604 14.875 11Z",
    fill: "#D7905D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 3.6875,
    r: 0.5625,
    fill: "#D7905D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 18.3125,
    r: 0.5625,
    fill: "#D7905D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8125,
    cy: 11,
    r: 0.5625,
    fill: "#D7905D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.1875,
    cy: 11,
    r: 0.5625,
    fill: "#D7905D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2713_2928",
    x: 0.25,
    y: 0.875,
    width: 22.5,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2713_2928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2713_2928",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigBlindCoin);
export default __webpack_public_path__ + "static/media/big-blind-coin.77a6b653797ce93f7b8a6583b74e1e3c.svg";
export { ForwardRef as ReactComponent };